/* === BEGIN imported: customComponent/downloadAppReminderContent.jsx === */
import React from "react";
import {hopnLanguageArray} from "@/utils/functions.js";
import {STORE_URLS} from "@/utils/deepLink.js";
import {qrCode, appStoreButton, playStoreButton} from "@img/index.js";

// `showSubtitle` is opt-out only: the booking-received deck's "Next Steps" card is
// tight on height and drops the live-location line. Every other caller (the standalone
// reminder step, Track Driver popup, return-booking tabs) keeps it.
export function DownloadAppReminderContent({onDone, showSubtitle = true}) {
    return (
        <div className="download-app-details" hopn-data-category="modal_download_app_reminder">
            <span className="title" hopn-data-index="download_app_title" hopn-data-category="modal_download_app_reminder">
                {hopnLanguageArray("modal_download_app_reminder", "download_app_title", "Download app to modify booking & track driver")}
                {showSubtitle && (
                    <p className="text-(--text-secondary) font-light">Live location will be visible once driver start the trip</p>
                )}
            </span>
            <div className="hopn-download-app-section">
                <div className="hopn-download-app-qr">
                    <img decoding="async" src={qrCode} alt={hopnLanguageArray("modal_download_app_reminder", "qr_code_alt", "QR code")}/>
                </div>
                <div className="hopn-download-app-links">
                    <a href={STORE_URLS.ios} target="_blank" rel="noopener noreferrer" className="hopn-app-store-button hopn-app-store-button-apple">
                        <img decoding="async" src={appStoreButton} alt={hopnLanguageArray("modal_download_app_reminder", "app_store_alt", "Download on App Store")}/>
                    </a>
                    <a href={STORE_URLS.android} target="_blank" rel="noopener noreferrer" className="hopn-app-store-button hopn-app-store-button-google">
                        <img decoding="async" src={playStoreButton} alt={hopnLanguageArray("modal_download_app_reminder", "google_play_alt", "Get it on Google Play")}/>
                    </a>
                </div>
            </div>
            {onDone && <button className="hopn-add-passenger-button no-icon" onClick={onDone}>Done</button>}
        </div>
    );
}
/* === END === */
